import React, { useEffect, useState } from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { appSettings } from "core/config";
import { ApplicationAction, BusinessPage } from "core/constants";
import { useUpdatePage } from "core/hooks";
import { sessionManager } from "core/instances";
import { LocalStorageHelper } from "core/lib/local-storage-helper";
import UrlUtils from "core/lib/url-utils";
import { Notice, ModalAlert } from "components/common-ui";

function CampaignSignUp() {
    const [updateTitle,] = useUpdatePage();
    const [customerNumber, setCustomerNumber] = useState<string>("");
    const customerNumberInputId = "customerNumberId";

    const isFieldTrials = appSettings.isEnabled.fieldTrials;

    //accountNumberQueryParam = "account";
    const customerIdQueryParam = "customer";

    const pageTitle = "Sign Up";

    const root = UrlUtils.getRootPath();
    const returnUrl = `${root}${BusinessPage.accountCreated}?action=${ApplicationAction.campaignSignUp}`;

    const gotoSignUp = () => {
        const input: any = document.getElementById(customerNumberInputId);
        const customerNumberValue = input.value?.trim();

        if (customerNumberValue === null || customerNumberValue.length === 0) {
            ModalAlert.error("Please enter your customer account number");
            return;
        }

        setCustomerNumber(customerNumberValue);
    }

    useEffectOnce(() => {
        updateTitle(pageTitle);

        const param = new URLSearchParams(window.location.search).get(customerIdQueryParam);

        if (!param) {
            return;
        }

        setCustomerNumber(param);
    });

    useEffect(() => {
        if (!customerNumber) {
            return;
        }

        LocalStorageHelper.clearLog();
        LocalStorageHelper.logout();
        // sessionManager.setValidateSalesForce(false);
        sessionManager.campaignData = { customerNumber: customerNumber };

        sessionManager.signUp(returnUrl);
    }, [customerNumber, returnUrl]);

    if (isFieldTrials && !customerNumber) {
        return (
            <Notice>
                <p>
                    <strong>Welcome to the DStv Business Self Service Field Trails</strong>
                </p>
                <p>
                    Please enter your Customer Number to initiate your sign up
                </p>
                <p>
                    <strong>Step 1 of 3</strong>
                </p>
                <p>
                    <input type="text" id={customerNumberInputId} />
                </p>
                <p className="mb-0">
                    <button className="btn btn-black" onClick={gotoSignUp}>Go to sign up</button>
                </p>
            </Notice>
        );
    }

    if (!isFieldTrials && !customerNumber) {
        return (
            <Notice>
                <p>
                    Invalid sign up link
                </p>
            </Notice>
        );
    }

    return (
        <Notice showSpinner={true}>
            <p>
                Redirecting to sign up
            </p>
        </Notice>
    );
}

export default CampaignSignUp;
